import React from 'react'
import Form from '@components/contact/6'
import { RealEstateDataPageComponentData } from 'types'
import useQueryDevelopment from '@hooks/useQueryDevelopment'
//Helpers
interface ExternalProps {
  propertyID: string
}

type CombinedProps = RealEstateDataPageComponentData & ExternalProps

const FormProperty = ({
  title,
  paragraph,
  propertyID,
  button,
  underlineMode,
  global_data,
  titleSecondary,
  showProducer,
  image,
  image_center,
}: CombinedProps) => {
  const { data } = useQueryDevelopment(propertyID, global_data.pageConfig.keys.tokko)
  return (
    <section id="Contacto">
      <Form
        underlineMode={underlineMode}
        property={data}
        data={data}
        titleSecondary={titleSecondary}
        title={title}
        paragraph={paragraph}
        button={button}
        from="development"
        image={image}
        image_center={image_center}
        global_data={global_data}
        showProducer={showProducer}
      />
    </section>
  )
}

export default FormProperty
